import { combineReducers } from 'redux'
import { authReducer } from './Auth/reducer'
import { registrationReducer } from './Registration/reducer'
import { profileReducer } from './Profile/reducer'
import { packageReducer } from './packages/reducer'
import { usersListReducer } from './list/reducer'
import { userDetailReducer } from './detail/reducer'
import { usersListSidebarReducer } from './listSidebar/reducer'

export const userReducer = combineReducers({
  auth: authReducer,
  registration: registrationReducer,
  profile: profileReducer,
  packages: packageReducer,
  list: usersListReducer,
  detail: userDetailReducer,
  listSidebar: usersListSidebarReducer
})
